import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { AuthService } from '@core/services/auth.service';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // Skip adding auth headers for external APIs
    const isExternalApi = this.isExternalApiCall(request.url);
    
    if (isExternalApi) {
      return next.handle(request);
    }

    return from(this.authService.getIdToken()).pipe(
      switchMap((idToken) => {
        if (!idToken) {
          return next.handle(request);
        }
        const authRequest = request.clone({
          setHeaders: { Authorization: `Bearer ${idToken}` },
        });
        return next.handle(authRequest);
      }),
      catchError((error) => {
        console.error('Error in jwtInterceptor', error);
        return next.handle(request);
      })
    );
  }

  private isExternalApiCall(url: string): boolean {
    const externalDomains = [
      'maps.googleapis.com',
      'maps.google.com',
      'googleapis.com',
      'google.com'
    ];
    
    return externalDomains.some(domain => url.includes(domain));
  }
}
